import { render } from "./myCerts.vue?vue&type=template&id=6515d7a7&scoped=true"
import script from "./myCerts.vue?vue&type=script&lang=js"
export * from "./myCerts.vue?vue&type=script&lang=js"

import "./myCerts.vue?vue&type=style&index=0&id=6515d7a7&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6515d7a7"]])

export default __exports__